import { render, staticRenderFns } from "./AMForgotInfoRootComponent.vue?vue&type=template&id=4b5b015b&scoped=true"
import script from "./AMForgotInfoRootComponent.vue?vue&type=script&lang=js"
export * from "./AMForgotInfoRootComponent.vue?vue&type=script&lang=js"
import style0 from "./AMForgotInfoRootComponent.vue?vue&type=style&index=0&id=4b5b015b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5b015b",
  null
  
)

export default component.exports